





















































































import MNotificationVue from "@/mixins/MNotification.vue";
import { CashFlowTransactionType } from "@/models/enums/CashFlowTransactionType.enum";
import {
  AccountOption,
  CashFlowMapping,
} from "@/models/interface/cash-flow-report-mapping";
import { Component, Mixins, Prop } from "vue-property-decorator";
import CashFlowAccountSelect from "./CashFlowAccountSelect.vue";
import CashFlowTransactionTypeSelect from "./CashFlowTransactionTypeSelect.vue";

@Component({
  components: {
    CashFlowAccountSelect,
    CashFlowTransactionTypeSelect,
  },
})
export default class CashFlowReportMappingRow extends Mixins(MNotificationVue) {
  @Prop({ type: Object, default: () => ({}) })
  readonly mapping!: CashFlowMapping;

  @Prop({ type: Boolean, default: false })
  readonly initiallyEditing!: boolean;

  @Prop({ required: true, type: Array })
  readonly accountOptions!: AccountOption[];

  isEditing = false;
  localName = "";
  localAccountSecureIds: string[] = [];
  localTransactionTypes: CashFlowTransactionType[] = [];

  get accountLabelMap(): Map<string, string> {
    return new Map(this.accountOptions.map(opt => [opt.id, opt.label]));
  }

  get transactionTypeLabelMap(): Map<CashFlowTransactionType, string> {
    return new Map(
      Object.values(CashFlowTransactionType).map(type => [
        type,
        this.$t(this.getI18nKey(type)) as string,
      ])
    );
  }

  getI18nKey(type: CashFlowTransactionType): string {
    const keyMap: Record<CashFlowTransactionType, string> = {
      [CashFlowTransactionType.AR_RECEIPT]: "lbl_ar_receipt",
      [CashFlowTransactionType.AP_PAYMENT]: "lbl_ap_payment",
      [CashFlowTransactionType.CASH_IN]: "lbl_cash_in",
      [CashFlowTransactionType.CASH_OUT]: "lbl_cash_out",
    };
    return keyMap[type];
  }

  created(): void {
    this.isEditing = this.initiallyEditing;
    this.localName = this.mapping.name;
    this.localAccountSecureIds = [...(this.mapping.accountSecureIds || [])];
    this.localTransactionTypes = [...(this.mapping.transactionTypes || [])];
  }

  handleAccountChange(accountSecureIds: string[]): void {
    this.localAccountSecureIds = accountSecureIds;
  }

  handleTransactionTypeChange(
    transactionTypes: CashFlowTransactionType[]
  ): void {
    this.localTransactionTypes = transactionTypes;
  }
  onSave(): void {
    this.isEditing = false;
    this.$emit("save", {
      name: this.localName,
      accountSecureIds: this.localAccountSecureIds,
      transactionTypes: this.localTransactionTypes,
    });
  }

  onDelete(): void {
    this.$confirm({
      title: this.$t("lbl_confirmation"),
      content: this.$t("lbl_modal_delete_title_confirm"),
      onOk: () => {
        this.$emit("delete");
      },
    });
  }

  onCancel(): void {
    this.$emit("cancel");
    this.isEditing = false;
  }
}
